<template>
<div>
    <div class="main-body desktop">
        <div class="circles">
            <div class="big-circle"></div>
            <div class="medium-circle"></div>
            <div class="small-circle"></div>
        </div>
        <div class="site-header">
            <router-link class="brand" to="/">
                <img class="logo-img" src="../assets/images/cs-logo-light.svg" alt="" />
            </router-link>
        </div>
        <b-row>
            <b-col cols="6"></b-col>
            <b-col class="mt-5 form-box">
                <p>Congratulations</p>
                <p>Your payment process was successful</p>
                <p>Redirecting in {{count}}</p>

            </b-col>
        </b-row>
        <div class="foot-text">
            <p>Welcome to Culture Square</p>
            <ul>
                <li>Sell</li>
                <li>Buy</li>
                <li>Host Events</li>
                <li>Attend Events</li>
            </ul>
        </div>

    </div>
    <div class="mobile">
        <AbstractHeader />
        <div class="form-box text-center">
            <p>Congratulations</p>
            <p>Your payment process was successful</p>
            <router-link class="btn btn-warning" to="/listings/events">All Listings</router-link>

        </div>
    </div>
</div>
</template>

<script>
import AbstractHeader from "@/components/AbstractHeader.vue";
export default {
    name: 'payment-success',
    components: {
        AbstractHeader
    },
    data: () => ({
        route: '',
        count: 5

    }),
    mounted() {
        this.route = this.$route.params.routeName
    },
    watch: {
        count: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.count--;
                    }, 1000);
                }
                else {
                    this.redirect()
                }
            },
            immediate: true // This ensures the watcher is triggered upon creation
        }
    },
    methods: {
        redirect() {
            const route = this.route;
            switch (route) {
                case 'interpreter':
                    this.$router.push("/languages/interpreters/manage?tab=isRequests");
                    break;
                case 'donate':
                    this.$router.push("/donate");
                    break;
                case 'chef':
                    this.$router.push("/recipes/hires?tab=isRequests");
                    break;
                case 'recipe':
                    this.$router.push("/recipes");
                    break;
                default:
                    this.$router.push("/dashboard");
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.main-body {
    height: 100vh;
    background-image: url('../assets/images/abstract.svg');
    background-repeat: no-repeat;
}

.site-header {
    padding: 30px 50px;
}

.form-control {
    height: calc(1.5em + 0.75rem + 15px) !important;
}

.logo-img {
    position: fixed;
    width: 8%
}

.circles {
    position: absolute
}

.big-circle {
    position: relative;
    left: 191%;
    top: -58px;
    height: 190px;
    width: 190px;
    border-radius: 50%;
    background: #F7B131;
}

.medium-circle {
    position: relative;
    left: 295%;
    top: -90px;
    height: 100px;
    width: 100px;
    border-radius: 50%;
    background: #F7B131;
}

.small-circle {
    position: relative;
    left: 300%;
    top: -50px;
    height: 62px;
    width: 62px;
    border-radius: 50%;
    background: #F7B131;
}

.form-container {
    background: none;
    box-shadow: none;
    padding: 30px 15px 15px 0px !important;
}

a {
    color: #F7B131;
}

.form-box {
    padding: 40px 75px 50px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 40px 20px 20px 20px;
    }
}

.form-box p:first-child {
    font-size: 28px;
    border-bottom: 1px solid #E0E0E0;
}

.foot-text {
    color: #fff;
    position: fixed;
    bottom: 0;
    padding-bottom: 1rem
}

.foot-text p {
    padding-left: 2.5rem;
    font-size: 14px
}

.foot-text ul {
    display: flex
}

.foot-text ul>li {
    margin: 0 10px;
}

.button-contain {
    margin-top: 80px;

}

.button-contain button {
    width: 100%
}

.svg-inline--fa {
    height: 0.7em !important
}

@media screen and (min-width: 1400px) {
    .big-circle {
        position: relative;
        left: 191%;
        top: -58px;
        height: 211px;
        width: 211px;
        border-radius: 50%;
        background: #F7B131;
    }

    .medium-circle {
        position: relative;
        left: 285%;
        top: -90px;
        height: 129px;
        width: 129px;
        border-radius: 50%;
        background: #F7B131;
    }

    .small-circle {
        position: relative;
        left: 280%;
        top: -50px;
        height: 62px;
        width: 62px;
        border-radius: 50%;
        background: #F7B131;
    }
}
</style>
